import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";

import { AuthGuard } from "./authentication/auth.guard";

import { FullComponent } from "./layout/full/full.component";
import { HomeComponent } from "./home/home.component";
import { FeedbackComponent } from "./core/feedback/feedback.component";
import { PortfolioComponent } from "./core/portfolio/portfolio.component";
import { SchemePortfolioComponent } from "./core/scheme-portfolio/scheme-portfolio.component";
import { ShareHoldingComponent } from "./core/share-holding/share-holding.component";
import { SchemeStatementsComponent } from "./core/scheme-statements/scheme-statements.component";
import { BlogComponent } from "./core/blog/blog.component";
import { PmsComponent } from "./core/pms/pms.component";

import { BlogDetailsComponent } from "./core/blog/blog-details.component";
import { PartnerComponent } from "./core/partner/partner.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: FullComponent,
    children: [
      { path: "", component: HomeComponent, pathMatch: "full" },
      { path: "home", component: HomeComponent },
      { path: "portfolio", component: PortfolioComponent },
      {
        path: "portfolio/:id",
        component: PortfolioComponent,
        canActivate: [AuthGuard]
      },
      { path: "share-holding/:id", component: ShareHoldingComponent },
      { path: "scheme-portfolio", component: SchemePortfolioComponent },
      {
        path: "scheme-portfolio/:id",
        component: SchemePortfolioComponent,
        canActivate: [AuthGuard]
      },
      { path: "scheme-key-trends/:id", component: SchemeStatementsComponent },
      { path: "feedback", component: FeedbackComponent },
      { path: "become-a-partner", component: PartnerComponent },
      {
        path: "",
        children: [
          {
            path: "explore",
            loadChildren: "./explore/explore.module#ExploreModule"
          }
        ]
      },
      {
        path: "",
        children: [
          {
            path: "nobias-recommended",
            loadChildren:
              "./nobias-recommended/nobias-recommended.module#NobiasRecommendedModule"
          }
        ]
      },
      {
        path: "blog",
        children: [
          { path: "", component: BlogComponent },
          { path: "details/:id", component: BlogDetailsComponent }
        ]
      },
      {
        path: "pms",
        children: [{ path: "", component: PmsComponent }]
      }
    ]
  },
  {
    path: "",
    component: FullComponent,
    children: [{ path: "user", loadChildren: "./user/user.module#UserModule" }]
  },
  {
    path: "",
    children: [
      {
        path: "authentication",
        loadChildren:
          "./authentication/authentication.module#AuthenticationModule"
      }
    ]
  },
  {
    path: "",
    component: FullComponent,
    children: [
      { path: "", loadChildren: "./static-views/static.module#StaticModule" }
    ]
  },
  { path: "**", redirectTo: "/authentication/404" }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(AppRoutes, {
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled",
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
